import { BrowserRouter as Router } from 'react-router-dom'
import withProvider from '../withProvider'

const withRouterProvider = withProvider(Router)

export default withRouterProvider
